import {
  MAP_CANDIDATE,
  MAP_CANDIDATE_SUCCESS,
  MAP_CANDIDATE_FAIL,
  GET_MAPPED_CANDIDATE_DETAILS,
  GET_MAPPED_CANDIDATE_DETAILS_SUCCESS,
  GET_MAPPED_CANDIDATE_DETAILS_FAIL,
  GET_MAPPED_CANDIDATES,
  GET_MAPPED_CANDIDATES_SUCCESS,
  GET_MAPPED_CANDIDATES_FAIL,
  GET_MAPPED_CANDIDATES_COUNT,
  GET_MAPPED_CANDIDATES_COUNT_SUCCESS,
  GET_MAPPED_CANDIDATES_COUNT_FAIL,
  GET_CANDIDATE_STATUS,
  GET_CANDIDATE_STATUS_SUCCESS,
  GET_CANDIDATE_STATUS_FAIL,
  GET_CANDIDATE_ACTIVITY_FEED,
  GET_CANDIDATE_ACTIVITY_FEED_SUCCESS,
  GET_CANDIDATE_ACTIVITY_FEED_FAIL,
} from "./actionTypes";

export const mapCandidate = (jobId, candidateId) => ({
  type: MAP_CANDIDATE,
  payload: { jobId, candidateId },
});

export const mapCandidateSuccess = (success) => ({
  type: MAP_CANDIDATE_SUCCESS,
  payload: success,
});

export const mapCandidateFail = (error) => ({
  type: MAP_CANDIDATE_FAIL,
  payload: error,
});

export const getMappedCandidateDetails = (jobId, candidateId) => ({
  type: GET_MAPPED_CANDIDATE_DETAILS,
  payload: { jobId, candidateId },
});

export const getMappedCandidateDetailsSuccess = (mappedCandidateDetails) => ({
  type: GET_MAPPED_CANDIDATE_DETAILS_SUCCESS,
  payload: mappedCandidateDetails,
});

export const getMappedCandidateDetailsFail = (error) => ({
  type: GET_MAPPED_CANDIDATE_DETAILS_FAIL,
  payload: error,
});

export const getMappedCandidates = (payload) => ({
  type: GET_MAPPED_CANDIDATES,
  payload: payload,
});

export const getMappedCandidatesSuccess = (mappedCandidates) => ({
  type: GET_MAPPED_CANDIDATES_SUCCESS,
  payload: mappedCandidates,
});

export const getMappedCandidatesFail = (error) => ({
  type: GET_MAPPED_CANDIDATES_FAIL,
  payload: error,
});
export const getMappedCandidatesCount = (payload) => ({
  type: GET_MAPPED_CANDIDATES_COUNT,
  payload: payload,
});

export const getMappedCandidatesCountSuccess = (mappedCandidatesCount) => ({
  type: GET_MAPPED_CANDIDATES_COUNT_SUCCESS,
  payload: mappedCandidatesCount,
});

export const getMappedCandidatesCountFail = (error) => ({
  type: GET_MAPPED_CANDIDATES_COUNT_FAIL,
  payload: error,
});

export const getCandidateStatus = (payload) => ({
  type: GET_CANDIDATE_STATUS,
  payload: payload,
});

export const getCandidateStatusSuccess = (data) => ({
  type: GET_CANDIDATE_STATUS_SUCCESS,
  payload: data,
});

export const getCandidateStatusFail = (error) => ({
  type: GET_CANDIDATE_STATUS_FAIL,
  payload: error,
});

export const getCandidateActivityFeed = (jobId, candidateId) => ({
  type: GET_CANDIDATE_ACTIVITY_FEED,
  payload: { jobId, candidateId },
});

export const getCandidateActivityFeedSuccess = (data) => ({
  type: GET_CANDIDATE_ACTIVITY_FEED_SUCCESS,
  payload: data,
});

export const getCandidateActivityFeedFail = (error) => ({
  type: GET_CANDIDATE_ACTIVITY_FEED_FAIL,
  payload: error,
});
